import { getIsFreeView } from 'library-@/utils/patent-view-free-judgment-util';
import _ from 'lodash';
export default {
    data() {
        const vm = this;
        return {
            compareData: {
                enabled: false,
                fullList: [
                    // {patentId, pn}
                ],
                targetIdx: 0,
                type: {},
                recover: false, // 语言不同，对比专利无文本等，通过该字段来控制对比内容是否显示，每次切换select重置false
                bindStatus: true, // 用来解决重复bindWording造成划线缺失的问题。
                get target() {
                    return vm.compareData.fullList[vm.compareData.targetIdx];
                },
            },
            isFree: getIsFreeView(),
        };
    },
    watch: {
        'compareData.recover'(bol) {
            if (!bol && this.emptyDensityData) {
                // 在切换select或打开对比开关时，手动清空右侧高亮密度条，避免专利语言不同时显示高密条切换select高密仍存在
                this.emptyDensityData();
            }
            if (bol && this.bindWording) {
                this.bindWording();
                if (this.compareData.bindStatus) {
                    this.compareData.bindStatus = false;
                }
            }
        },
    },
    methods: {
        compareTargetIdxChange(i) {
            this.compareData.targetIdx = i;
            this.compareData.recover = false;
            this.compareData.bindStatus = true;
        },
        compareEnabledChange(bol) {
            this.compareData.enabled = bol;
            this.compareData.recover = false;
        },
        closeCompare() {
            this.compareData.recover = true;
        },

        // format compare data
        formatCompareData(list) {
            return _.map(list, item => {
                if (item.compare_with_type === 'CLM_MODIFY') {
                    return {
                        ...item,
                        name: this.$t('fileWrapperMultiView.claimsAmendment', { mrdt: item.mrdt }),
                        id: item.pfw_id,
                    };
                }
                return {
                    ...item,
                    name: item.pn,
                    id: item.patent_id,
                };
            });
        },
    },
};
